import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLocalizedPath } from '../hooks/useLocalizedPath';
import { SEOMeta } from '../components/SEOMeta';
import { ConformiteImpact, ConformiteRegulations } from '../components/sections/conformite';
import { FinalCTA } from '../components/sections/home';
import { RelatedPages } from '../components/RelatedPages';
import styles from './Conformite.module.css';

export function Conformite() {
  const { t } = useTranslation('solutions');
  const { lp } = useLocalizedPath();

  return (
    <>
      <SEOMeta title={t('conformiteHero.title')} description={t('conformiteHero.subtitle')} />

      <div className={styles.aboveFold}>
        <div className={styles.aboveFoldBg} />
        <div className={styles.heroZone}>
          <span className={styles.heroBadge}>{t('conformiteHero.badge')}</span>
          <h1 className={styles.heroTitle}>{t('conformiteHero.title')}</h1>
          <p className={styles.heroSubtitle}>{t('conformiteHero.subtitle')}</p>

          <div className={styles.statCard}>
            <span className={styles.statValue}>{t('conformiteHero.scope3Value')}</span>
            <span className={styles.statLabel}>{t('conformiteHero.scope3Label')}</span>
            <span className={styles.statSource}>{t('conformiteHero.scope3Source')}</span>
          </div>

          <Link
            to={lp('/contact')}
            className={styles.heroCta}
          >
            {t('conformiteHero.cta')}
          </Link>

          <div className={styles.scrollIndicator} aria-hidden="true">
            <div className={styles.chevron} />
            <div className={styles.chevron} />
            <div className={styles.chevron} />
          </div>
        </div>
      </div>

      <ConformiteImpact />
      <ConformiteRegulations />
      <RelatedPages currentFrPath="/solutions/conformite" />
      <FinalCTA ns="solutions" prefix="conformiteCTA" />
    </>
  );
}
